<div class="cnaes-view">
    <div class="row">
        <div class="form-group col-12">
            <sgt-cnae-form-control-text
                label="CNAE Principal"
                helpText="Atividade Econômica Principal da empresa"
                [cnae]="cnaePrincipal">
            </sgt-cnae-form-control-text>
        </div>
    </div>
    
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                CNAEs Secundárias
            </h6>
            <p class="form-text text-muted">
                Atividades Econômicas Secundárias da empresa
            </p>
        </div> 
        <sgt-cnae-table-view
            [isShowIndicadores]="false"
            entityText="Nenhuma CNAE Secundária"
            [cnaes]="cnaesSecundarias">
        </sgt-cnae-table-view>
    </div>
</div>
